import React, { useState, useEffect } from "react";
import {
    Modal,
    Form,
    Input,
    Button,
    Select,
    InputNumber,
    notification,
} from "antd";
import axiosGet, { axiosPost } from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
const { Option } = Select;

const CorporateManual = (props: any) => {
    const [visible, setVisible] = useState(false);
    const [selectedRowInfo, setSelectedRowInfo]: any = useState({});
    const [companySearchedList, setCompanySearchedList] = useState([]);
    const [selectedValues, setSelectedValues]: any = useState({});
    const [companyList, setCompanyList] = useState([]);
    const [username, setUsername]: any = useState(
        localStorage.getItem("employeename")
    );
    const [employeename, setemployeename]: any = useState(
        localStorage.getItem("employeename")
    );
    const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));


    useEffect(() => {
        setVisible(props.visible);
    }, [props.visible]);

    useEffect(() => {
        if (props.visible) {
            if (props.selectedRowData && props.selectedRowData.length > 0) {
                setSelectedRowInfo(props.selectedRowData[0]);
            }
            getcomapanylist();
        }
    }, [props.selectedRowData, props.visible]);


    const getcomapanylist = () => {

        const options: any = {
            params: {
                cityid: "CBE001",
            },
        };
        axiosGet(UrlConstants.getCompanyList, options)
            .then((resp: any) => {
                setCompanyList(resp);
                console.log(resp);
            })
            .catch(function (error: any) {
                if (error.response) {
                    console.log(error.response.data, error.response.status);
                }
            });
    };

    const handleOk = (e: any) => {
        props.hideModal(false);
    };

    const handleCancel = (e: any) => {
        setSelectedValues({});
        props.hideModal(false);
    };

    const layout = {
        labelCol: { span: 10 },
        wrapperCol: { span: 16 },
    };

   

    const Conerttogst = (values:any) => {
        const options: any = {
            data: {
                bookingid: selectedRowInfo.id,
                companyName: selectedValues.companyName,
            },
        };
        axiosPost(UrlConstants.normaltogstbill, options)
            .then((resp: any) => {
                const notificationInfo: any = {
                    header: "Invoice Coverted Succesfully",
                    description:
                        "Booking Id: " + selectedRowInfo.id + " Invoice converted for company" + selectedValues.companyName ,
                };
                openNotificationWithIcon("Success", notificationInfo);
                handleOk("close");
            })
            .catch(function (error: any) {
                if (error.response) {
                    console.log(error.response.data, error.response.status);
                }
                const notificationInfo = {
                    header: "Invoice Conversion Failed",
                    description: "Error Occurred while Converting Invoice",
                };
                openNotificationWithIcon("Error", notificationInfo);
            });
    };

    const openNotificationWithIcon = (type: any, info: any) => {
        if (type === "Success") {
            notification.success({
                message: info.header,
                description: info.description,
            });
        } else if (type === "Error") {
            notification.error({
                message: info.header,
                description: info.description,
            });
        }
    };

    const validateMessages = {
        required: "${label} is required!",
        types: {
            email: "${label} is not validate email!",
            number: "${label} is not a validate number!",
        },
        number: {
            range: "${label} must be between ${min} and ${max}",
        },
    };

    const onCompanyChange = (value: any, fullInfo: any) => {
    selectedValues.companyName = fullInfo.children;
    setSelectedValues(selectedValues);

  };
    return (
        <Modal
            destroyOnClose={true}
            className="custom-modal-cancel-form"
            title={props.title}
            width={650}
            visible={visible}
            // onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
        >
            <Form
                {...layout}
                name="nest-messages"
               // onFinish={onFinish}
                validateMessages={validateMessages}
            >
                <Form.Item name={["user", "bookingId"]} label="Booking Id" rules={[]}>
                    <Input defaultValue={selectedRowInfo.id} readOnly={true} />
                </Form.Item>
                <Form.Item name={["user", "cabId"]} label="Cab Id" rules={[]}>
                    <Input defaultValue={selectedRowInfo.cabid} readOnly={true} />
                </Form.Item>
                <Form.Item
                    name={["user", "callerReason"]}
                    label="Company"
                    rules={[{ required: true }]}
                >
                    <Select
                        showSearch
                        value={selectedValues.reason}
                        placeholder="Select Company"
                        optionFilterProp="children"
                        onChange={onCompanyChange} 
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                        dropdownMatchSelectWidth={false} 
                    >
                        {companyList.map((companyName: any) => (
                            <Option key={companyName.id} value={companyName.id}>
                                {companyName.companyname}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                    <Button
                        className="custom-modal-approve-attendance-approve-btn"
                        htmlType="submit"
                        onClick={Conerttogst}
                    >
                        Submit
                    </Button>
                    <Button
                        className="custom-modal-cancel-form-submit-btn"
                        htmlType="button"
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CorporateManual;
